<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">{{ changeTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container class="pt-5 pb-1">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newForm.department"
                type="text"
                hide-details
                label="Nome"
                outlined
                dense
                @input="
                  (v) => {
                    newForm.department = v.toUpperCase()
                  }
                "
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn dark color="primary" text @click="close"> Sair </v-btn>
        <v-btn dark color="blue darken-1" @click="setSubmit"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NewDepartment',
  props: {
    dialog: Boolean,
    closeDialog: {
      type: Function,
      default: function () {
        return ''
      },
    },
    departmentData: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data: function () {
    return {
      form: {
        department: null,
      },
    }
  },
  computed: {
    changeTitle() {
      var title = Object.keys(this.departmentData).length === 0 ? 'Cadastrar setor' : 'Editar setor'
      return title
    },
    newForm() {
      let newValue = {}
      if (Object.keys(this.departmentData).length > 0) {
        newValue = this.departmentData
      } else {
        newValue = this.form
      }
      return newValue
    },
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('utils', ['ActionSetAdminDepartment', 'ActionUpdateAdminDepartment']),
    async saveDepartment() {
      if (this.form.department === null) {
        return
      } else {
        this.ActionSetLoading(true)
        try {
          await this.ActionSetAdminDepartment({ ...this.form }) //ActionStoreDepartment
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Setor cadastrado com sucesso',
          })
          this.close()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível cadastrar setor.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    async updateDepartment() {
      if (!this.departmentData.department) {
        return
      } else {
        this.ActionSetLoading(true)
        try {
          await this.ActionUpdateAdminDepartment({ ...this.departmentData })
          this.$swal({
            icon: 'success',
            title: 'Atualizado',
            text: 'Setor atualizado com sucesso.',
          })
          this.closeDialog()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível atualizar setor.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    close() {
      this.closeDialog()
      this.form = {}
    },
    setSubmit() {
      if (Object.keys(this.departmentData).length === 0) {
        this.saveDepartment()
      } else {
        this.updateDepartment()
      }
    },
  },
}
</script>
